<template>
    <div>
        <b-table
            :empty-text="this.$t('there_are_no_records')"
            bordered
            striped
            responsive
            :items="documents"
            :fields="documentsFields"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded document_request_dropdown">
            <template #cell(file)="row">
                <b-button v-if="row.item.file || row.item.id == 2696" variant="link">{{row.item.name}} <i class="ri-download-2-fill"></i></b-button>
                <b-form-group v-else>
                    <div class="d-flex custom-file-upload">
                        <b-form-file v-model="selectedFile"
                                     :placeholder="$t('select_file')"
                                     :drop-placeholder="$t('drop_file')"
                                     :ref="'fileInput'+row.item.id"
                                     :multiple="false"></b-form-file>
                        <b-button variant="outline-secondary" @click="$refs['fileInput'+row.item.id].$el.childNodes[0].click();">{{ $t('browse') }}</b-button>
                    </div>
                </b-form-group>
            </template>
        </b-table>
    </div>
</template>
<script>

import {ValidationObserver, ValidationProvider} from "vee-validate"
import ParameterService from "@/services/ParameterService"
import qs from "qs";

export default {
    props: {
        userId: {
            type: Number,
        }
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            documents: null,
            documentsFields: [
                {
                    key: this.getLocaleField('name'),
                    label: this.$t('documents'),
                },
                {
                    key: 'file',
                    label: '',
                },
            ],
            selectedFile: null,
        }
    },
    methods: {
        getDocuments(){
            const config = {
                params: {
                    parameter_code: 'internship_documents'
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false }),
            }
            ParameterService.getItemsPublic(config).then(response => {
                this.documents = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        }
    },
    created() {
        this.getDocuments()
    },

    watch: {

    }
}
</script>
